"use client";

import { useEffect, useRef } from "react";
import { useAppDispatch } from "@/_hooks/hooks";
import { setSettingList, setBannerList } from "@/screens/home/homeSlice";
import { setPropertyList } from "@/screens/property/propertySlice";
import { setPackageList } from "@/screens/package/packageSlice";

interface GlobalHydrationProps {
  data: {
    settings: any[];
    banners: any[];
    properties: any[];
    packages: any[];
  };
}

export function GlobalHydration({ data }: GlobalHydrationProps) {
  const dispatch = useAppDispatch();
  const hydrated = useRef(false);

  if (!hydrated.current && data) {
    dispatch(setSettingList(data.settings));
    dispatch(setBannerList(data.banners));
    dispatch(setPropertyList(data.properties));
    dispatch(setPackageList(data.packages));
    hydrated.current = true;
  }

  return null;
}
